module.exports = __webpack_public_path__ + "img/yy-s8.d6d70401.svg";